module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gc-Da-Ef.c4dec122.png";